import React, { Component } from "react";
import { ModalComponent } from "../modal";
import { ModalTemplate } from "../modalTemplate";
import { ERROR_MSG } from "../../../constant";
import htmlToFormattedText from "html-to-formatted-text";
import { RedirectUser } from "../../reusableComponent";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
const toolbarConfig = {
  toolbar: [
    ["bold", "italic", "underline", "strike"],
    [{ header: "1" }, { header: "2" }],
    [{ size: [] }],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" }
    ]
  ]
};
const formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "video"
];
export class NoteComponent extends Component {
  state = {
    error: {},
    message: "",
    modalclose: false,
    isValueChange: false,
    textCount: 0,
    textCountMessage: "",
    editorHtml: "",
    theme: "snow"
  };
  componentDidMount() {
    const { message } = this.props;
    this.setState({ message: message });
  }
  handleChange(html, quill) {
    this.setState({ message: html });
  }
  validateField = async (fieldName, value) => {
    let _error = {
      comment: {
        error: value === null || !value.trim(),
        message: (value === null || !value.trim()) && ERROR_MSG.DEFAULT_MSG
      }
    };

    this.setState(
      {
        error: { ..._error }
      },
      () => {
        return true;
      }
    );
  };
  validateForm = async (fieldName, projectnotes) => {
    const { isValueChange, textCount } = this.state;
    //console.log(textCount+1)
    let { onSubmit, value } = this.props;
    //console.log(projectnotes)
    if (isValueChange) {
      onSubmit(fieldName, "");
    } else if (projectnotes != "") {
      onSubmit(fieldName, projectnotes);
    } else {
      onSubmit(fieldName, value);
    }
  };
  render() {
    const { error, message } = this.state;
    const {
      show = false,
      onClose = () => {},
      onChange = () => {},
      title = "Add Comment",
      onSubmitTitle = "Add",
      isLoading = false,
      value = "",
      hideProgressbar,
      projectNotemodifyDate,
      projectNoteuserId,
      projectNoteuserName
    } = this.props;
    let characterLimitReached = false;
    return (
      <div>
        {show ? (
          <ModalComponent
            centered={true}
            onClose={() => {
              this.setState({ error: {} }, () => {
                onClose("closemodal");
              });
            }}
            containerClass="nodal-officer-popup comment-modal-body note-modal projectnote-modal"
            isLoading={isLoading}
            hideProgressbar={hideProgressbar}
            template={
              <ModalTemplate
                bodyTemplate={
                  <>
                    <h4>{title}</h4>
                    <div className="email_editor projectnote-editor">
                      <ReactQuill
                        onChange={(html, quill) =>
                          this.handleChange(html, quill)
                        }
                        value={message == null ? "" : message}
                        theme={this.state.theme}
                        modules={toolbarConfig}
                        formats={formats}
                        bounds={".app"}
                        placeholder={"Type your Note here..."}
                        ref={el => {
                          this.reactQuillRef = el;
                        }}
                      />

                      <div style={{ paddingTop: 3 }}>
                        <span className="remaining-char">
                          Remaining characters :{" "}
                          <span
                            className="remaining-char"
                            style={{
                              color:
                                2000 - htmlToFormattedText(message).length < 0
                                  ? "red"
                                  : "#848584"
                            }}
                          >
                            {2000 - htmlToFormattedText(message).length}
                          </span>
                        </span>
                        {projectNotemodifyDate == null ? (
                          <span
                            className="last-modified-text"
                            style={{ visibility: "hidden" }}
                          >
                            Last modified by
                          </span>
                        ) : (
                          <>
                            <span className="last-modified-text">
                              Last modified by{" "}
                              <RedirectUser
                                title={projectNoteuserName}
                                id={projectNoteuserId}
                                projectnotecss={true}
                              />{" "}
                              On {projectNotemodifyDate}
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                  </>
                }
                onSubmit={() => {
                  this.validateForm("projectnote", this.state.message);
                }}
                onClose={() => {
                  this.setState({ error: {} }, () => {
                    onClose("closemodal");
                  });
                }}
                onSubmitTitle={onSubmitTitle}
                submitDisable={
                  2000 - htmlToFormattedText(message).length < 0 ? true : false
                }
              />
            }
          />
        ) : null}
      </div>
    );
  }
}
